export default __webpack_public_path__ + "static/media/ic-void.86cf7506.svg";